import {
  COLLECTION_UPLOAD_URL,
  DOCUMENT_CHUNK_URL,
  DOCUMENT_UPLOAD_URL,
  STYLE_TEMPLATES_CHUNK_URL,
  STYLE_TEMPLATES_UPLOAD_URL,
  UPLOAD_ENTITY_TYPES,
} from "constants/documentUploads";
import { selectContractDetail } from "slices/contracts/detail/selectors";
import { selectCurrentMiscAnalysis } from "slices/miscAnalysis";
import { selectOpportunity } from "slices/opportunity/summary/selectors";
import { selectProposal } from "slices/proposals/proposal/selectors";
import { selectFolders } from "slices/workspace/selectors";

const getFieldsByEntityType = (selector, entityType) => (state) => {
  const data = selector(state);

  return { entityType, entityId: data?.id };
};

const DEFAULT_URLS = {
  uploadUrl: DOCUMENT_UPLOAD_URL,
  chunkUrl: DOCUMENT_CHUNK_URL,
};

export const UPLOAD_TARGET_CONFIG = {
  [UPLOAD_ENTITY_TYPES.COLLECTIONS]: {
    chunkUrl: "/rag/upload/chunk",
    uploadUrl: COLLECTION_UPLOAD_URL,
  },
  [UPLOAD_ENTITY_TYPES.DOC_STYLE_TEMPLATES]: {
    chunkUrl: STYLE_TEMPLATES_CHUNK_URL,
    uploadUrl: STYLE_TEMPLATES_UPLOAD_URL,
  },
  [UPLOAD_ENTITY_TYPES.FOLDER]: {
    ...DEFAULT_URLS,
    getFields: (state) => {
      const { folderId } = selectFolders(state);

      return { folderId };
    },
  },

  [UPLOAD_ENTITY_TYPES.OPPORTUNITY]: {
    ...DEFAULT_URLS,
    getFields: getFieldsByEntityType(
      selectOpportunity,
      UPLOAD_ENTITY_TYPES.OPPORTUNITY
    ),
  },

  [UPLOAD_ENTITY_TYPES.CONTRACT]: {
    ...DEFAULT_URLS,
    getFields: getFieldsByEntityType(
      selectContractDetail,
      UPLOAD_ENTITY_TYPES.CONTRACT
    ),
  },

  [UPLOAD_ENTITY_TYPES.PROPOSAL]: {
    ...DEFAULT_URLS,
    getFields: getFieldsByEntityType(
      selectProposal,
      UPLOAD_ENTITY_TYPES.PROPOSAL
    ),
  },

  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS]: {
    ...DEFAULT_URLS,
    getFields: getFieldsByEntityType(
      selectCurrentMiscAnalysis,
      UPLOAD_ENTITY_TYPES.MISC_ANALYSIS
    ),
  },
};
